import React, {
  ReactElement,
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { Row, Col, Space, Button } from "antd";
import PizZip from "pizzip";
import Docxtemplater from "docxtemplater";
import { saveAs } from "file-saver";
import { data } from "data/env";
import { checkEmptyObj } from "helper/common";

interface TemplateProps {
  data: any;
  templatePath: string;
  outputName: string;
  label: string;
  children?: ReactElement;
}

const RenderTemplate = forwardRef(
  (
    {
      data = {},
      templatePath = "",
      outputName = "default.docx",
      label = "Download DOCX",
      children,
    }: TemplateProps,
    ref: any
  ) => {
    const [recall, setRecall] = useState<boolean>(false);

    useImperativeHandle(ref, () => ({
      fillDocx: () => {
        fillDocxTemplate(data);
      },
    }));

    //*---------Khi call đồng thời dữ liệu và template----------- */
    useEffect(() => {
      if (recall) {
        fillDocxTemplate(data);
      }
      return () => setRecall(false);
    }, [recall, data]);
    //*---------------------------------------------------------- */

    //*---------Khi data nhận vào là 1 mảng-------------- */
    useEffect(() => {
      if (data.length > 0) {
        for (let i = 0; i < data.length; i++) {

          fillDocxTemplate(data[i]);
        }
      }
    }, [data]);
    //*-------------------------------------------------- */

    const fillDocxTemplate = async (currentData) => {
      // Đường dẫn tới file DOCX cố định
      const templateFilePath = templatePath;

      // Đọc nội dung của file DOCX
      if (!checkEmptyObj(currentData) && !Array.isArray(currentData)) {
        await fetch(templateFilePath)
          .then((response) => response.arrayBuffer())
          .then((content) => {
            const zip = new PizZip(content);
            let doc;

            try {
              doc = new Docxtemplater(zip);
            } catch (error) {
              console.error("Error creating Docxtemplater:", error);
              return;
            }

            doc.setData(currentData);

            try {
              doc.render();
            } catch (error) {
              console.error("Error rendering template:", error);
              return;
            }

            const outputBuffer = doc.getZip().generate({ type: "blob" });

            // Tải file về máy tính
            saveAs(outputBuffer, outputName);
          })
          .catch((error) => {
            console.error("Error loading template file:", error);
          });
      } else setRecall(true);
    };

    const handleClick = () => {
      fillDocxTemplate(data);
    };

    return (
      <Col span={8}>
        <Space direction="vertical" style={{ width: "100%" }} className="mb-2">
          <Row>
            <div ref={ref} onClick={handleClick}>
              {children || <Button>{label}</Button>}
            </div>
          </Row>
        </Space>
      </Col>
    );
  }
);
export default RenderTemplate;
